import React, { useEffect, useState } from 'react';
import { FaRocket, FaClock, FaUsers, FaChartLine, FaChevronDown } from 'react-icons/fa';
import { GlowEffect } from '../components/ui/GlowEffect';
import kevinKhanImage from '../assets/kevin-khan.jpg';



// NEW REVAMPED PAGE STYLES
const pageContainerStyle = {
  width: '100%',
  minHeight: '100vh',
  background: '#fff'
};

const gradientHeaderStyle = {
  padding: '180px 20px 100px 20px',
  textAlign: 'center',
  background: 'linear-gradient(135deg, #2AF598 0%, #08B3E5 100%)'
};

const mainHeaderStyle = {
  fontSize: '4.2rem',
  fontWeight: '700',
  color: '#ffffff',
  marginBottom: '30px',
  lineHeight: '1.2',
  maxWidth: '1200px',
  margin: '0 auto 30px auto',
  textShadow: '0 4px 24px rgba(0,0,0,0.12), 0 1.5px 6px rgba(0,0,0,0.10)'
};

const subHeaderStyle = {
  fontSize: '1.4rem',
  color: '#ffffff',
  opacity: 0.9,
  maxWidth: '800px',
  margin: '0 auto',
  lineHeight: '1.6'
};

const ctaStyle = {
  padding: '80px 20px',
  background: '#f0fffa',
  textAlign: 'center',
  color: '#3d3479'
};

const finalHeaderStyle = {
  fontSize: '2.8rem',
  fontWeight: '400',
  marginBottom: '30px',
  maxWidth: '800px',
  margin: '0 auto 30px auto',
  color: '#045C5C'
};

const finalButtonStyle = {
  background: 'linear-gradient(135deg, #2AF598 0%, #08B3E5 100%)',
  color: 'white',
  border: 'none',
  padding: '18px 40px',
  borderRadius: '8px',
  fontSize: '1.3rem',
  fontWeight: '600',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  textDecoration: 'none',
  display: 'inline-block',
  marginTop: '20px'
};

// New section styles
const featureSectionStyle = {
  width: '100%',
  padding: '80px 20px',
  background: '#ffffff'
};

const containerStyle = {
  maxWidth: '1200px',
  margin: '0 auto'
};

const headerContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '40px',
  marginBottom: '60px'
};

const titleContainerStyle = {
  display: 'flex',
  gap: '16px',
  flexDirection: 'column',
  alignItems: 'center'
};

const titleStyle = {
  fontSize: '3rem',
  fontWeight: '400',
  maxWidth: '600px',
  lineHeight: '1.2',
  color: '#045C5C',
  textAlign: 'center',
  margin: 0
};

const descriptionStyle = {
  fontSize: '1.125rem',
  maxWidth: '600px',
  lineHeight: '1.6',
  color: '#6c757d',
  textAlign: 'center',
  margin: 0
};

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
  gap: '32px'
};

const cardWrapperStyle = {
  position: 'relative',
  display: 'inline-block',
  borderRadius: '12px',
  padding: '2px',
  height: '100%'
};

const cardStyle = {
  background: '#ffffff',
  borderRadius: '10px',
  border: '1px solid #e5e7eb',
  height: '100%',
  padding: '24px',
  aspectRatio: '1',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  overflow: 'hidden',
  zIndex: 1
};

const largeCardWrapperStyle = {
  ...cardWrapperStyle,
  gridColumn: 'span 2'
};

const largeCardStyle = {
  ...cardStyle,
  aspectRatio: 'auto'
};

const iconStyle = {
  width: '32px',
  height: '32px',
  color: '#045C5C'
};

const iconContainerStyle = {
  height: '60px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  marginBottom: '8px'
};

const cardContentStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%'
};

const cardTitleStyle = {
  fontSize: '1.25rem',
  fontWeight: '600',
  color: '#045C5C',
  margin: '16px 0 8px 0',
  lineHeight: '1.3',
  textAlign: 'left'
};

const cardDescriptionStyle = {
  color: '#6c757d',
  maxWidth: '320px',
  fontSize: '1rem',
  lineHeight: '1.5',
  margin: 0,
  textAlign: 'left'
};

const largeCardContentStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  textAlign: 'left',
  maxWidth: '66%',
  margin: '0'
};

const largeCardTitleStyle = {
  fontSize: '1.25rem',
  fontWeight: '600',
  color: '#045C5C',
  margin: '0 0 8px 0',
  lineHeight: '1.2',
  textAlign: 'left'
};

const largeCardDescriptionStyle = {
  color: '#6c757d',
  fontSize: '1rem',
  lineHeight: '1.5',
  margin: 0,
  textAlign: 'left'
};

// FAQ Section Styles
const faqSectionStyle = {
  width: '100%',
  padding: '80px 20px',
  background: '#ffffff'
};

const faqContainerStyle = {
  maxWidth: '1200px',
  margin: '0 auto'
};

const faqTitleStyle = {
  fontSize: '3rem',
  fontWeight: '400',
  color: '#045C5C',
  textAlign: 'center',
  margin: '0 0 60px 0',
  lineHeight: '1.2'
};

const accordionStyle = {
  width: '100%'
};

const accordionItemStyle = {
  borderBottom: '1px solid #e5e7eb'
};

const accordionTriggerStyle = {
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '24px 0',
  fontSize: '1.125rem',
  fontWeight: '500',
  color: '#045C5C',
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  textAlign: 'left',
  transition: 'all 0.2s ease'
};

const accordionContentStyle = {
  overflow: 'hidden',
  transition: 'all 0.2s ease-out'
};

const accordionContentInnerStyle = {
  paddingBottom: '24px',
  paddingTop: '0',
  fontSize: '1rem',
  lineHeight: '1.6',
  color: '#6c757d',
  textAlign: 'left'
};

const chevronStyle = {
  width: '16px',
  height: '16px',
  transition: 'transform 0.2s ease',
  flexShrink: 0,
  marginLeft: '16px'
};

// Founder Section Styles
const founderSectionStyle = {
  width: '100%',
  padding: '80px 20px',
  background: '#f0fffa'
};

const founderHeaderStyle = {
  textAlign: 'center',
  marginBottom: '60px'
};

const founderTitleStyle = {
  fontSize: '3rem',
  fontWeight: '400',
  color: '#045C5C',
  margin: '0',
  lineHeight: '1.2'
};

const founderContentStyle = {
  display: 'flex',
  gap: '60px',
  alignItems: 'center',
  maxWidth: '1200px',
  margin: '0 auto',
  flexWrap: 'wrap'
};

const founderContentMobileStyle = {
  ...founderContentStyle,
  flexDirection: 'column',
  textAlign: 'center',
  gap: '40px'
};

const founderImageContainerStyle = {
  flex: '0 0 auto'
};

const founderImageWrapperStyle = {
  width: '462px',
  height: '462px',
  borderRadius: '50%',
  background: 'linear-gradient(135deg, #2AF598 0%, #08B3E5 100%)',
  padding: '6px',
  boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
};

const founderImageStyle = {
  width: '450px',
  height: '450px',
  borderRadius: '50%',
  objectFit: 'cover',
  display: 'block'
};

const founderTextStyle = {
  flex: '1'
};

const founderBioStyle = {
  fontSize: '1.125rem',
  lineHeight: '1.7',
  color: '#6c757d',
  marginBottom: '24px'
};

function About() {
  // FAQ accordion state
  const [openItems, setOpenItems] = useState({});
  
  // Mobile screen detection
  const [isMobile, setIsMobile] = useState(false);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Check if mobile on initial load
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handlePricingClick = () => {
    // Navigate to home page pricing section
    window.location.href = '/#pricing';
  };

  const toggleAccordionItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqData = [
    {
      question: "Is AI going to try to replace me as a teacher?",
      answer: "Absolutely not. Our entire philosophy is Empowerment, Not Replacement. AI is brilliant at repetitive tasks like scheduling, sending reminders, and processing payments. It is terrible at inspiration, motivation, and nuanced musical feedback. We handle the boring stuff so you have more energy for the important stuff."
    },
    {
      question: "I'm a musician, not a tech expert. Is this difficult to set up?",
      answer: "Not at all. We designed the platform to be intuitive and easy to use, even for those who aren't tech-savvy. Our onboarding process guides you through every step, and our human support team is always here to help you get started and feel confident."
    },
    {
      question: "How is this different from just using a generic calendar app?",
      answer: "A generic calendar is a blank slate. MusicTeachers.ai is a purpose-built ecosystem for your studio. It understands concepts like make-up lesson policies, automated invoicing, managing different lesson types, and reducing no-shows. It's the difference between an empty notebook and a dedicated studio manager."
    },
    {
      question: "How does MusicTeachers.ai actually save me money?",
      answer: "Our platform helps you in two main ways: First, it plugs the leaks: By reducing no-shows by up to 90% and making it easy to enforce your cancellation policies, you stop losing income. And second, it creates capacity: By automating hours of admin work each week, you gain time that you can use to teach more students, increasing your earning potential without increasing your stress."
    },
    {
      question: "How quickly can I get started?",
      answer: "You can have your professional website up and running within 24-48 hours, and the scheduling system will be ready to use within a week. Our AI generates a customized website based on your teaching style and preferences, and our team helps you configure the scheduling system to match your studio policies. Most teachers are fully operational within a week."
    },
    {
      question: "Is my student and studio data safe?",
      answer: "Yes. Protecting your data is a top priority. We use industry-standard security practices and are committed to ethical data handling. Your business is your own, and your data will always be treated with the utmost respect and confidentiality."
    }
  ];

  return (
    <div style={pageContainerStyle}>
      {/* Gradient Header Section */}
      <section style={gradientHeaderStyle}>
        <h1 style={mainHeaderStyle}>
        Our Mission: To Give Music Teachers Back Their Time
        </h1>
        <p style={subHeaderStyle}>
        We believe the world needs more music, which means we need teachers who are inspired, not inundated. MusicTeachers.ai was born from a simple conviction: technology should serve the artist. It should handle the administrative chaos so you can focus on the creative magic of teaching.
        </p>
      </section>

      {/* Meet the Founder Section */}
      <section style={founderSectionStyle}>
        <div style={containerStyle}>
          <div style={founderHeaderStyle}>
            <h2 style={founderTitleStyle}>Meet the Founder</h2>
          </div>
          <div style={isMobile ? founderContentMobileStyle : founderContentStyle}>
            <div style={founderImageContainerStyle}>
              <div style={founderImageWrapperStyle}>
                <img 
                  src={kevinKhanImage} 
                  alt="Kevin Khan, Founder of MusicTeachers.ai" 
                  style={founderImageStyle}
                />
              </div>
            </div>
            <div style={founderTextStyle}>
              <p style={founderBioStyle}>
                My journey in music began at age eight, behind the keys of a piano. For nearly a decade, music has been a core part of my life, teaching me discipline, creativity, and passion.
              </p>
              <p style={founderBioStyle}>
                As I got older, I saw my own teachers waste hours on things that had nothing to do with music: wrestling with outdated websites, managing a never-ending stream of scheduling emails, and dealing with last-minute cancellations. They were brilliant musicians who were being held back by technology.
              </p>
              <p style={founderBioStyle}>
                As a 17-year-old high school junior who grew up as a digital native, I knew I could solve this problem by bridging my two worlds—music and technology.
              </p>
              <p style={founderBioStyle}>
                MusicTeachers.ai is the solution I built to fix this. We create the beautiful, professional websites that attract your ideal students, and our AI assistant takes the headache of scheduling completely off your plate.
              </p>
              <p style={founderBioStyle}>
                My mission is simple: you handle the music, and we'll handle the rest.
              </p>
              <p style={founderBioStyle}>(And hopefully, help pay for my college tuition along the way!)</p>
              <p style={{...founderBioStyle, fontWeight: '600', marginTop: '30px'}}>
                Kevin Khan, Founder
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Feature Cards Section */}
      <section style={featureSectionStyle}>
        <div style={containerStyle}>
          <div style={headerContainerStyle}>
            <div style={titleContainerStyle}>
              <h2 style={titleStyle}>
                Our Commitment is to You.
              </h2>
              <p style={descriptionStyle}>
                These Are the Values We Live By.
              </p>
            </div>
          </div>
          <div style={gridStyle}>
            <div style={cardWrapperStyle}>
              <GlowEffect
                colors={["#2AF598", "#22E4AC"]}
                mode="static"
                blur="medium"
              />
              <div style={cardStyle}>
                <div style={iconContainerStyle}>
                  <FaRocket style={iconStyle} />
                </div>
                <div style={cardContentStyle}>
                  <div>
                    <h3 style={cardTitleStyle}>You Are Our North Star.</h3>
                  </div>
                  <div>
                    <p style={cardDescriptionStyle}>
                    Every feature we build starts with a simple question: "Does this make a teacher's life easier?" We are obsessively teacher-centric. We don't just design for you; we design with you, constantly listening to feedback to ensure our platform fits into your world, not the other way around.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div style={cardWrapperStyle}>
              <GlowEffect
                colors={["#1BD7BB", "#14C9CB"]}
                mode="static"
                blur="medium"
              />
              <div style={cardStyle}>
                <div style={iconContainerStyle}>
                  <FaClock style={iconStyle} />
                </div>
                <div style={cardContentStyle}>
                  <div>
                    <h3 style={cardTitleStyle}>AI as an Assistant, Not a Replacement.</h3>
                  </div>
                  <div>
                    <p style={cardDescriptionStyle}>
                    Let's be clear: AI will never replace the human connection that creates a great musician. Our vision is unwavering: AI handles the logistics; you handle the magic. Our technology is built to augment your expertise, freeing you from mundane tasks so you can provide the nuanced guidance that only a human teacher can.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div style={cardWrapperStyle}>
              <GlowEffect
                colors={["#0FBED8", "#08B5E5"]}
                mode="static"
                blur="medium"
              />
              <div style={cardStyle}>
                <div style={iconContainerStyle}>
                  <FaUsers style={iconStyle} />
                </div>
                <div style={cardContentStyle}>
                  <div>
                    <h3 style={cardTitleStyle}>A Community of Support.</h3>
                  </div>
                  <div>
                    <p style={cardDescriptionStyle}>
                    We know that teaching can sometimes feel isolating. We are committed to fostering a strong community and providing exceptional, human-powered support. We see the statistic that nearly half of music teachers consider leaving the profession due to stress, and our goal is to be a partner in changing that narrative for the better.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* <div style={largeCardWrapperStyle}>
              <GlowEffect
                colors={["#1BD7BB", "#14C9CB", "#0FBED8", "#08B5E5"]}
                mode="static"
                blur="medium"
              />
              <div style={largeCardStyle}>
                <FaChartLine style={iconStyle} />
                <div style={largeCardContentStyle}>
                  <h3 style={largeCardTitleStyle}>Principled & Ethical Innovation.</h3>
                  <p style={largeCardDescriptionStyle}>
                  Trust is everything. We are dedicated to the responsible and ethical application of AI in education. This means respecting your privacy, protecting your data, and building tools that enhance human creativity. We use technology to provide data-driven insights that empower you, not to commoditize your art.
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section style={faqSectionStyle}>
        <div style={faqContainerStyle}>
          <h2 style={faqTitleStyle}>Your Questions, Answered Honestly.</h2>
          <div style={accordionStyle}>
            {faqData.map((item, index) => (
              <div key={index} style={accordionItemStyle}>
                <button
                  style={accordionTriggerStyle}
                  onClick={() => toggleAccordionItem(index)}
                  onMouseEnter={(e) => {
                    e.target.style.textDecoration = 'underline';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.textDecoration = 'none';
                  }}
                >
                  {item.question}
                  <FaChevronDown 
                    style={{
                      ...chevronStyle,
                      transform: openItems[index] ? 'rotate(180deg)' : 'rotate(0deg)'
                    }} 
                  />
                </button>
                <div 
                  style={{
                    ...accordionContentStyle,
                    height: openItems[index] ? 'auto' : '0',
                    opacity: openItems[index] ? '1' : '0'
                  }}
                >
                  {openItems[index] && (
                    <div style={accordionContentInnerStyle}>
                      {item.answer}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section style={ctaStyle}>
        <h2 style={finalHeaderStyle}>
        Ready to Experience the Difference?
        </h2>
                  <p style={{fontSize: '1.2rem', marginBottom: '30px', color: '#6c757d', maxWidth: '1200px', margin: '0 auto 30px auto'}}>
            Join a growing community of empowered music educators. See how our platform can transform your administrative chaos into creative calm and help you build the studio you've always dreamed of.
          </p>
        <button 
          style={finalButtonStyle}
          onClick={handlePricingClick}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 8px 25px rgba(0,0,0,0.2)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
        >
          View Pricing Plans
        </button>
      </section>
    </div>
  );
}



export default About; 